import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'core/utils/apiClient';

type QueryResponse = {
  /** 救急隊ID。 */
  emsTeamId: string;
  /** 救急隊名。 */
  emsTeamName: string;
  /** アクセスレベル。 */
  accessLevel: string;
  /** 消防本部ID */
  departmentId: string;
  /** ユーザーID */
  userId: string;
};

export const useCurrentUserEmsTeam = () => {
  const { data, isLoading } = useQuery<QueryResponse>({
    queryKey: ['my_info'],
    queryFn: async () => {
      const response = await apiClient.get<QueryResponse>("/my_info");
      return response.data;
    },
  });

  return { emsTeam: data, isLoading };
};
